var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.004,
    height: 17.998,
    viewBox: "0 0 18.004 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_supporto_ticket",
    "data-name": "icona supporto/ticket",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Unione_14",
    "data-name": "Unione 14",
    d: "M-17634-16528a9,9,0,0,1,9-9,9,9,0,0,1,9,9,8.993,8.993,0,0,1-9,9A8.993,8.993,0,0,1-17634-16528Zm9,7.594a7.592,7.592,0,0,0,7.594-7.594,7.59,7.59,0,0,0-7.594-7.6,7.59,7.59,0,0,0-7.594,7.6,7.558,7.558,0,0,0,.451,2.584l3.668-1.975a4.465,4.465,0,0,1-.525-2.109,4.5,4.5,0,0,1,4.5-4.5,4.362,4.362,0,0,1,1.307.2l-2.6,2.6a1,1,0,0,0,0,1.416l1.584,1.584a1,1,0,0,0,1.416,0l2.6-2.6a4.407,4.407,0,0,1,.2,1.311,4.5,4.5,0,0,1-4.5,4.5,4.451,4.451,0,0,1-2.111-.527l-2.354,4.006A7.566,7.566,0,0,0-17625-16520.4Z",
    transform: "translate(17634 16537)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.1cde1e801540b42948b3244c6f3eee7b.svg";
export { ForwardRef as ReactComponent };